import {
  SplitScenarioAction,
  SplitScenarioModalAction,
  SplitScenarioURL,
} from './SplitScenarioConstants';
import { SplitScenarioObject, SplitScenarioState } from './SplitScenarioTypes';
import { SplitScenario } from '../../../types';

const initialState = {
  list: [],
  item: {},
  modal: {
    state: false,
    action: '',
  },
};

export default function(state = initialState, action: any) {
  switch (action.type) {
    case SplitScenarioAction.FETCH_SPLITSCENARIO:
      return {
        ...state,
        list: action.payload.SplitScenarioList,
      };

    case SplitScenarioAction.SHOW_SPLITSCENARIO:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          state: action.payload.modal.state,
          action: action.payload.modal.action,
        },
      };

    case SplitScenarioAction.HIDE_SPLITSCENARIO:
      return {
        ...state,
        modal: {
          ...state.modal,
          state: false,
        },
      };

    case SplitScenarioAction.UPDATE_SPLITSCENARIO_ITEM:
      return {
        ...state,
        item: action.payload.item,
      };

    case SplitScenarioAction.CLONE_SPLITSCENARIO:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          ...action.payload.modal,
        },
      };

    case SplitScenarioAction.UPDATE_SPLITSCENARIO_LIST:
      return {
        ...state,
        list: action.payload.SplitScenarioList,
      };

    case SplitScenarioAction.SAVE_SPLITSCENARIO:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          state: action.payload.modal.state,
        },
      };

    case SplitScenarioAction.DELETE_SPLITSCENARIO:
      return {
        ...state,
      };

    case SplitScenarioAction.BUYERGROUP_SPLITSCENARIO:
      return {
        ...state,
        buyergroup: action.payload.data,
      };

    case SplitScenarioAction.GET_SIGNUP_COLUMNS:
      return {
        ...state,
        signupColumns: action.payload.data,
      };

    default:
      return state;
  }
}
